export default __webpack_public_path__ + "static/media/bg.92fb89b0.jpg";